import { AdminStatsCard } from "@/components/admin/AdminStatsCard";
import { Users, Calculator, FileText } from "lucide-react";

interface DashboardStatsProps {
  stats: {
    totalClients: number;
    totalCalculations: number;
    totalDocuments: number;
  };
}

export const DashboardStats = ({ stats }: DashboardStatsProps) => {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <AdminStatsCard 
          icon={Users}
          label="Total Clients"
          value={stats.totalClients}
          iconColor="text-blue-500"
        />
        <AdminStatsCard 
          icon={Calculator}
          label="Total Calculations"
          value={stats.totalCalculations}
          iconColor="text-green-500"
        />
        <AdminStatsCard 
          icon={FileText}
          label="Total Documents"
          value={stats.totalDocuments}
          iconColor="text-purple-500"
        />
      </div>
    </div>
  );
};